import React, { createContext, useCallback, useContext, useState } from 'react';
import { asyncLocalStorage } from '../Helpers/LocalStorage';

import Desgin from '../Assets/Photos/tshirt.png';
import Image from '../Assets/Photos/ImageGallary.png';

const UserContext = createContext();

export function useUser() {
    return useContext(UserContext);
}

export default function UserProvider({ children }) {
    const [token, setToken] = useState(null);
    const [role, setRole] = useState(null);
    const [name, setName] = useState(null);
    const [profile, setprofile] = useState(null);
    const [walletMoney, setwalletMoney] = useState(null);
    const [cart, setCart] = useState(null);
    const [address, setaddress] = useState(null);
    const [orderStep, setOrderStep] = useState(null);
    const login = useCallback((token, name, role, money, profile) => {
        setToken(token);
        setprofile(profile);
        setRole(role);
        setName(name);
        setwalletMoney(money);
        setOrderStep(0);
        setaddress({
            name: 'Ronak Sarvaiya',
            add1: '201',
            add2: 'Shiv Sagar App.',
            add3: 'Joshipura Sak Market',
            city: 'JUNAGADH',
            state: 'Gujarat',
            pin: '360001',
            country: 'India',
            phone: '08153849384',
            email: 'ronaksarvaiya55555@gmail.com',
            shipper: 'Cogminds Delhivery',
            charges: 55,
        });
        setCart([]);
    }, []);
    const logout = useCallback(async () => {
        await asyncLocalStorage.removeItem('token');
        setToken(null);
        setRole(null);
        setName(null);
    }, []);

    const addMoney = useCallback((money) => {
        setwalletMoney((prev) => prev + money);
    }, []);

    const removeMoney = useCallback((money) => {
        setwalletMoney((prev) => prev - money);
    }, []);

    const changeName = useCallback((newName) => {
        setName(newName);
    }, []);

    //Control Items on cart
    const addItem = useCallback(() => {
        setCart((prev) => [
            ...prev,
            {
                id: prev.length,
                name: 'Butter Yellow M Men Round',
                notes: ['Only 8 in Stock'],
                price: 183.75,
                quantity: 1,
                img: Image,
                color: 'rgba(0, 0, 0, 1)',
                size: 'S',
                desgin: {
                    front: Desgin,
                    back: Desgin,
                    sleeve: Desgin,
                },
            },
        ]);
    });

    const updateACartItem = useCallback(({ id, property, newValue }) => {
        setCart((prev) => {
            const old = [...prev];
            old[id][property] = newValue;
            return old;
        });
    }, []);

    const clearCart = useCallback(() => {
        setCart([]);
    });

    const changeQtyCart = useCallback(({ id, qty }) => {
        const index = cart.findIndex((prev) => prev.id === id);
        if (index === -1) {
            return;
        }
        if (qty <= 0) {
            setCart((prev) => {
                const old = [...prev];
                old.splice(index, 1);
                return old;
            });
        } else {
            setCart((prev) => {
                const old = [...prev];
                old[index].quantity = qty;
                return old;
            });
        }
    });

    const value = {
        token,
        role,
        name,
        profile,
        walletMoney,
        cart,
        address,
        orderStep,
        setOrderStep,
        changeQtyCart,
        logout,
        login,
        changeName,
        addMoney,
        removeMoney,
        addItem,
        clearCart,
        updateACartItem,
    };
    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
